<template>
    <div>
        <nuxt-child />
    </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
    name: 'TopicMain',
    layout: 'Topic',
    auth: false
}) 
</script>

<style lang="scss" scoped>

</style>